import { Checkbox } from 'primereact/checkbox';
import { useState } from 'react';


export function PropertyCheckbox({propertyName, initialVal, label, id, onDone}) {
    const [val, setVal] = useState(initialVal);

    return(
        <div className='flex align-items-center'>
            <Checkbox 
                onChange={(e) => {
                    setVal(e.checked);
                    onDone(propertyName,e.checked);
                }}
                inputId={id + '-' + propertyName}
                checked={val}
                name={propertyName}
            />
            <label htmlFor={id + '-' + propertyName} className='ml-2'>{label}</label>
        </div>
    )

}